module.exports = __webpack_public_path__ + "images/meta/ogp/bonuscp_ogp_400147f5949560a16c45791dcea48234.png";